import { render } from "./LearningHub.vue?vue&type=template&id=ecf3896e&scoped=true"
import script from "./LearningHub.vue?vue&type=script&lang=js"
export * from "./LearningHub.vue?vue&type=script&lang=js"

import "./LearningHub.vue?vue&type=style&index=0&id=ecf3896e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecf3896e"]])

export default __exports__